export default {
    mainContainer: {
        display: 'flex', 
        flexDirection: 'column', 
        gap: '30px'
    },
    inputContainer: {
        display: 'flex', 
        gap: '20px', 
        width: '50%', 
        alignSelf: 'center', 
        alignItems: 'center', 
        marginTop: '40px'
    },
    whiteSpacePre: {
        whiteSpace: 'pre'
    },
    statusLabel: {
        fontSize: '16px', 
        alignSelf: 'center'
    },
    fontWeight700: {
        fontWeight: 700
    },
}